import React from 'react';
import PropTypes from 'prop-types';
import { isExpired } from '@/utils/dateTimeUtils';
import ConnectButton from '@/pages/_banner/ConnectButton';
import Wrapper from '@/pages/_banner/Wrapper';
import { DialogManager } from '@/dialogs_new/DialogManager';
import useDialogLauncher from '@/dialogs-routable/_hooks/useDialogLauncher';
import usePageRouter from '@/dialogs-routable/_hooks/usePageRouter';

DiscoverBanner.propTypes = {
  offer: PropTypes.shape({
    id: PropTypes.number,
    data: PropTypes.shape({
      endDate: PropTypes.string
    })
  }).isRequired,
  creator: PropTypes.shape({
    data: PropTypes.shape({
      firstName: PropTypes.string
    })
  }).isRequired
};

export default function DiscoverBanner(props) {
  const { offer, creator } = props;

  const launch = useDialogLauncher();
  const { history } = usePageRouter();

  function showConnectDialog() {
    launch(DialogManager.ClaimDiscover.Config(offer.id));
  }

  if (
    isExpired(offer.data.endDate)
  ) {
    return (
      <Wrapper
        color="gray"
        creator={creator}
        title="The timeframe for this offer has ended."
        subtitle={(
          <>
            But you can explore other opportunities to collaborate and make an impact.
          </>
        )}
      >
        <div className="flex flex-col sm:flex-row space-x-0 space-y-4 sm:space-x-4 sm:space-y-0">
          <ConnectButton color="gray" onClick={() => history.push(`/opportunities`)}>
            Explore opportunities
          </ConnectButton>
        </div>
      </Wrapper>
    );
  }

  return (
    <Wrapper
      creator={creator}
      title={`Interested in ${creator.data.firstName}'s offer?`}
      subtitle={(
        <>
          Connect with {creator.data.firstName} to share your interest. You can ask questions,
          provide ideas, and share insights on how this offer could support you and others.
        </>
      )}
    >
      <div className="flex flex-col sm:flex-row space-x-0 space-y-4 sm:space-x-4 sm:space-y-0">
        <ConnectButton onClick={showConnectDialog}>
          Start the conversation
        </ConnectButton>
      </div>
    </Wrapper>
  );
};
